import { lazy } from "react";
import SalesForAutoCare from "./Sales/POS/salesForAutoCare";
// import { useSelector } from "react-redux";
// import { authRoles } from "../auth";
// import AutoLogout from "./AutoLogout";

const Transfer = lazy(() => import("./Store/Transfer/stockTransfer"));
const Quotation = lazy(() => import("./Store/Quotation/salesQuotation"));
const Dashboard = lazy(() => import("./Dashboard/dashboard"));
const Customer = lazy(() => import("./Customer/customer"));
const Suppliers = lazy(() => import("./Suppliers/Supplier/suppliers"));
const Expenses = lazy(() => import("./Expenses/expenses"));
const ExpenseCategory = lazy(()=> import ("./Expenses/ExpansesCategory/expensesCategory"))
const CreditAndDebit =lazy(()=> import("./AccountDetails/CreditAndDebit"))
const Reports = lazy(() => import("./Reports/reports"));
const Settings = lazy(() => import("./Settings/settings"));
const ItemMaster = lazy(() => import("./Stock/Item_Master/itemMaster"));
const Bin = lazy(() => import("./Stock/Bin/bin"));
const ItemCategory = lazy(() => import("./Stock/Category/category"));
const SalesRep = lazy(() => import("./SalesRep/salesRep"));
const Users = lazy(() => import("./Users/users"));
const UserType = lazy(() => import("./Users/User-Type/userType"));
//const Sales = lazy(() => import("./Sales/POS/salesWithPackSize"));
const Sales = lazy(() => import("./Sales/POS/sales"));
const InvoiceReversal = lazy(() => import("./InvoiceReversal/Reversal"))
const Barcode = lazy(() => import("./Barcode/barcode"));
const Route = lazy(() => import("./SalesRep/Route/route"));
const Colour = lazy(() => import("./Stock/Colour/colour"));
const Brand = lazy(() => import("./Stock/Brand/brand"));
const BatchNo = lazy(() => import("./Stock/BatchNo/BatchNo"));
const Unit = lazy(() => import("./Stock/Unit/unit"));
const Grn = lazy(() => import("./Store/GRN/grn"));
const Cheques = lazy(() => import("./Cheque/chequeInHand"));
const ProcessingCheques = lazy(() => import("./Cheque/ChequeDeposit"));
const ReturnedCheques = lazy(() => import("./Cheque/returnedCheques"));
const ChequeRealized = lazy(() => import("./Cheque/ChequRealized"))

const StockIssue = lazy(() => import("./Store/Stock-Issue/stockIssue"));
const SalesOrder = lazy(() => import("./Store/SalesOrder/salesOrder"));
const PurchaseReturn = lazy(() =>
  import("./Suppliers/PurchaseReturn/purchaseReturn")
);
const SalesReturn = lazy(() => import("./Customer/SalesReturn/salesReturn"));

const PaymentReceipt = lazy(() =>
  import("./Customer/Payment-receipt/paymentReceipt")
);
const PaymentReceiptReversal = lazy(() =>
  import("./Customer/ReceiptReverse/paymentReceiptReverse")
);
const PaymentVouchers = lazy(() =>
  import("./Suppliers/PaymentVouchers/paymentVouchers")
);
const PaymentVoucherReversal = lazy(() =>
  import("./Suppliers/VoucherReverse/paymentVoucherReverse")
);
const ChequeVoucher = lazy(() => import("./ChequeVoucher/chequeInHand"));
const ChequeVoucherInProcess = lazy(() => import("./ChequeVoucher/chequesInProcess"));
const ReturnedChequeVoucher = lazy(() => import("./ChequeVoucher/returnedCheques"));
const ReturnChequePayment = lazy(() => import("./Cheque/ReturnChequePayment/RetunChequePayment"));

const PaidGrn = lazy(() => import("./Store/GRN/paidGrn"));
const UpComingServices = lazy(() => import("./Vehicle/upCommingServices"));
const Vehicle = lazy(() => import("./Vehicle/Vehicle"));
const ServicePack = lazy(() =>
  import("./Vehicle/Service-packages/servicePackages")
);
const Advancepayment = lazy(()=>import("./Customer/Advancepayment/Advancepayment"))
const AdvancepayamentRevesal = lazy(()=>import("./Customer/Advancepayment/AdvancePaymentReverse/advancepaymentReversal"))
export const cashierRouteConfig = {
  settings: {},
  auth: ["admin", "cashier"],
  routes: [
    { path: "/customer", component: Customer },
    { path: "/sales", component: Sales },
    { path: "/sales-auto-care", component: SalesForAutoCare },
    { path: "/barcode", component: Barcode },
    { path: "/service-pack", component: ServicePack },
    { path: "/vehicle", component: Vehicle },
    { path: "/upcoming-service", component: UpComingServices },
    {path:"/advance-payment", component:Advancepayment},
    {path:"/advance-payment-reversal", component:AdvancepayamentRevesal}
  ],
};

export const authorisedRouteConfig = {
  settings: {},
  auth: ["admin"],
  routes: [
    // { path: "/auto-logout", component: AutoLogout },
    { path: "/dashboard", component: Dashboard },
    {path:"/invoice-reversal", component:InvoiceReversal},
    { path: "/cheques", component: Cheques },
    { path: "/returned-cheque", component: ReturnedCheques },
    { path: "/cheques-process", component: ProcessingCheques },
    { path: "/sales-order", component: SalesOrder },
    { path: "/stock-issue", component: StockIssue },
    { path: "/stock-transfer", component: Transfer },
    { path: "/sales-quotation", component: Quotation },
    { path: "/salesRep", component: SalesRep },
    { path: "/suppliers", component: Suppliers },
    { path: "/expenses", component: Expenses },
    { path: "/expenses-category", component: ExpenseCategory },
    {path:"/AccountDetails/CreditAndDebit", component:CreditAndDebit },
    { path: "/reports", component: Reports },
    { path: "/item-master", component: ItemMaster },
    { path: "/item-category", component: ItemCategory },
    { path: "/user", component: Users },
    { path: "/user-type", component: UserType },
    { path: "/sales-return", component: SalesReturn },
    { path: "/payment-receipt", component: PaymentReceipt },
    { path: "/receipt-reversal", component: PaymentReceiptReversal },
    { path: "/payment-vouchers", component: PaymentVouchers },
    { path: "/voucher-reversal", component: PaymentVoucherReversal },
    { path: "/route", component: Route },
    { path: "/item-bin", component: Bin },
    { path: "/item-colour", component: Colour },
    { path: "/item-brand", component: Brand },
    { path: "/item-unit", component: Unit },
    { path: "/batchNo", component: BatchNo },
    { path:"/cheque-realized", component: ChequeRealized },

    { path: "/grn", component: Grn },
    { path: "/grn-paid", component: PaidGrn },
    { path: "/chequePayment", component: ReturnChequePayment },
    { path: "/settings", component: Settings },
    { path: "/purchase-return", component: PurchaseReturn },
    { path: "/cheque-vouchers", component: ChequeVoucher },
    { path: "/cheque-vouchers-process", component: ChequeVoucherInProcess },
    { path: "/returned-cheque-vouchers", component: ReturnedChequeVoucher },

  ],
};
